
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import { Component, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { SimpleProxyForm } from "@/UI/components/Helpers/SimpleProxyForm";
import { RecordDataForm } from "@/form/visits/New/Record";
import { Table, Tabs } from "ant-design-vue";
import Vue from "vue";

@Component({
    components: {
        BaseDataForm,
        "a-tabs": Tabs,
        "a-tab-pane": Tabs.TabPane,
        "a-table": Table,
    },
})
export default class RecordStatus extends mixins(SimpleProxyForm) {
    @Prop() form!: RecordDataForm;
    @Prop() disabled!: boolean;
    status = 1;

    setStatus(key: string): void {
        if (!this.disabled) {
            this.form.status_id = Number(key);
            this.status = Number(key);
            this.$emit('status-change', Number(key));
        }
    }
    async mounted(): Promise<void> {
        // this.status = JSON.parse(Vue.router.currentRoute.params.params)["status_id"];

        // const tabs = document.querySelectorAll('.ant-tabs-tab')
        // const activeTab = tabs[this.status]
        // activeTab.setAttribute('aria-selected', 'true');
        // activeTab.click();

        // this.status = this.form.status_id;
    }
    async created(): Promise<void> {

        try {
            this.status = this.form.status_id;
            this.formReady = true;
        } catch (e) {
            this.formReady = false;
            console.error("Error ");
            console.error(e);
        }
    }
}
